// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    firebase: {
        apiKey: "AIzaSyBquQOVo4xjYWNhKj3RgJcg9B8g0HEDr6c",
        authDomain: "lionsgatesphere.firebaseapp.com",
        projectId: "lionsgatesphere",
        storageBucket: "lionsgatesphere.appspot.com",
        messagingSenderId: "712709308760",
        appId: "1:712709308760:web:6ac792552a091d1cd6e52d",
        measurementId: "G-2X1P9MQ69S"
    },
    production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
